
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies",
      function () {
        return require("private-next-pages/policies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies"])
      });
    }
  